// ============================================
// СЛАЙДЕР ПРЕПОДАВАТЕЛЕЙ
// ============================================
// Код слайдера преподавателей вынесен из script.js
// Включает: десктопный слайдер, мобильную карусель, переключение по кампусам

// ============================================
// СЛАЙДЕР ПРЕПОДАВАТЕЛЕЙ (BLOCK14)
// ============================================
(function() {
  function initTeachersSlider() {
    if (document.body.classList.contains('middle-high-page') && !document.querySelector('[data-landing-staff-js]')) return;
    const teachersSlides = document.getElementById('teachersSlides');
    const prevBtn = document.getElementById('teachersPrev');
    const nextBtn = document.getElementById('teachersNext');
    
    if (!teachersSlides || !prevBtn || !nextBtn) return;
  
  let cards = teachersSlides.querySelectorAll('.teacher_card');
  let currentPage = 0;
  
  // Функция для определения количества карточек, которые полностью помещаются в блок по ширине
  function getVisibleCardsCount() {
    if (cards.length === 0) return 0;
    
    const containerRect = teachersSlides.getBoundingClientRect();
    const containerWidth = containerRect.width;
    let visibleCount = 0;
    let totalWidth = 0;
    const gap = 34; // gap между карточками из CSS
    
    for (let i = 0; i < cards.length; i++) {
      const card = cards[i];
      const cardRect = card.getBoundingClientRect();
      const cardWidth = cardRect.width;
      
      // Учитываем gap только между карточками (не перед первой)
      const widthWithGap = i > 0 ? cardWidth + gap : cardWidth;
      
      if (totalWidth + widthWithGap <= containerWidth) {
        totalWidth += widthWithGap;
        visibleCount++;
      } else {
        break;
      }
    }
    
    return visibleCount;
  }
  
  // Функция для вычисления максимального количества нажатий направо
  function getMaxNextClicks() {
    const visibleCount = getVisibleCardsCount();
    return Math.max(0, cards.length - visibleCount);
  }
  
  let maxNextClicks = getMaxNextClicks(); // Максимальное количество нажатий направо
  
  // Функция для определения количества карточек для прокрутки
  function getCardsToScroll() {
    return 1;
  }
  
  // Функция для пересчета totalPages
  function getTotalPages() {
    const cardsToScroll = getCardsToScroll();
    return Math.ceil(cards.length / cardsToScroll);
  }
  
  function scrollToPage(page) {
    const cardsToScroll = getCardsToScroll();
    const totalPages = getTotalPages();
    
    if (page < 0) page = 0;
    if (page >= totalPages) page = totalPages - 1;
    
    currentPage = page;
    const index = page * cardsToScroll;
    const card = cards[index];
    
    if (card) {
      const containerRect = teachersSlides.getBoundingClientRect();
      const cardRect = card.getBoundingClientRect();
      const scrollLeft = teachersSlides.scrollLeft + (cardRect.left - containerRect.left) - 10;
      
      teachersSlides.scrollTo({
        left: scrollLeft,
        behavior: 'smooth'
      });
    }
    
    updateButtons();
  }
  
  prevBtn.addEventListener('click', () => {
    scrollToPage(currentPage - 1);
  });
  
  nextBtn.addEventListener('click', () => {
    // Проверяем, не превысили ли максимальное количество нажатий направо
    if (currentPage < maxNextClicks) {
      scrollToPage(currentPage + 1);
    }
  });
  
  function updateButtons() {
    const totalPages = getTotalPages();
    prevBtn.style.opacity = currentPage > 0 ? '1' : '0.5';
    prevBtn.style.cursor = currentPage > 0 ? 'pointer' : 'not-allowed';
    
    // Кнопка направо активна только если не превышено максимальное количество нажатий
    const canClickNext = currentPage < maxNextClicks;
    nextBtn.style.opacity = canClickNext ? '1' : '0.5';
    nextBtn.style.cursor = canClickNext ? 'pointer' : 'not-allowed';
  }
  
  // Пересчитываем при изменении размера окна
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      // Пересчитываем maxNextClicks при изменении размера
      maxNextClicks = getMaxNextClicks();
      // Пересчитываем currentPage при изменении размера
      currentPage = Math.min(currentPage, getTotalPages() - 1);
      updateButtons();
    }, 100);
  });
  
  // Убеждаемся, что клики работают на карточках
  cards.forEach(card => {
    card.style.pointerEvents = 'auto';
    card.style.cursor = 'pointer';
  });
  
  // Добавляем обработчик клика на карточки преподавателей
  cards.forEach(card => {
    card.addEventListener('click', (e) => {
    });
  });
  
  updateButtons();
  
  // Глобальная функция для обновления навигации после изменения карточек
  window.updateTeachersNavigation = function() {
    if (window.innerWidth > 768) {
      // Обновляем список карточек
      cards = teachersSlides.querySelectorAll('.teacher_card');
      // Пересчитываем maxNextClicks
      maxNextClicks = getMaxNextClicks();
      // Сбрасываем currentPage
      currentPage = 0;
      // Обновляем кнопки
      updateButtons();
      // Убеждаемся, что клики работают на новых карточках
      cards.forEach(card => {
        card.style.pointerEvents = 'auto';
        card.style.cursor = 'pointer';
      });
    }
  };
  } // Закрываем функцию initTeachersSlider
  
  // Вызываем функцию инициализации при загрузке DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTeachersSlider);
  } else {
    initTeachersSlider();
  }
})();


// ============================================
// ПЕРЕКЛЮЧЕНИЕ ПРЕПОДАВАТЕЛЕЙ ПО КАМПУСАМ (BLOCK14)
// ============================================
(function() {
  function initBlock14CampusSwitching() {
  if (document.body.classList.contains('middle-high-page') && !document.querySelector('[data-landing-staff-js]')) return;
  const teachersSlides = document.getElementById('teachersSlides');
  const campusButtons = document.querySelectorAll('.block14_campus_btn');
  const block14CampusSelectorBtn = document.getElementById('block14CampusSelectorBtn');
  const block14CampusModal = document.getElementById('block14CampusModal');
  const block14SelectedCampus = document.getElementById('block14SelectedCampus');
  // Мобильный селектор (для 768px и меньше)
  const block14CampusSelectorBtnMobile = document.getElementById('block14CampusSelectorBtnMobile');
  const block14CampusModalMobile = document.getElementById('block14CampusModalMobile');
  const block14SelectedCampusMobile = document.getElementById('block14SelectedCampusMobile');
  const block14CampusOptions = document.querySelectorAll('.block14_campus_option');

  if (!teachersSlides) return;

  let teacherCards = Array.from(teachersSlides.querySelectorAll('.teacher_card'));

  // Сохраняем базовый набор преподавателей (Сколково) из верстки
  const baseTeachers = teacherCards.map(card => {
    const img = card.querySelector('.teacher_photo');
    const nameEl = card.querySelector('.teacher_name');
    const positionEl = card.querySelector('.teacher_position');

    let src = img ? img.getAttribute('src') : '';
    // Убеждаемся, что пути указывают на папку spb для остальных городов
    if (src && !src.includes('/gorki/') && !src.includes('/tashkent/')) {
      // Если путь не содержит gorki или tashkent, заменяем на spb
      src = src.replace('/landing_2025/src/img/Staff/teacher_', '/landing_2025/src/img/Staff/spb/teacher_');
      src = src.replace('/landing_2025/src/img/Staff/spb/spb/', '/landing_2025/src/img/Staff/spb/'); // На случай двойной замены
    }
    src = landingAssetPath(src);

    return {
      src: src,
      alt: img ? img.getAttribute('alt') || '' : '',
      name: nameEl ? nameEl.textContent : '',
      position: positionEl ? positionEl.textContent : ''
    };
  });

  function rotateTeachers(shift) {
    const len = baseTeachers.length;
    return baseTeachers.map((_, index) => {
      const srcIndex = (index + shift) % len;
      return baseTeachers[srcIndex];
    });
  }

  // Данные преподавателей для Горки (10 преподавателей)
  const gorkiTeachers = [
    {
      src: landingAssetPath('/landing_2025/src/img/Staff/gorki/kristofer.webp'),
      alt: 'Кристофер Кингшотт',
      name: 'Кристофер Кингшотт',
      position: 'Директор кампуса Горки'
    },
    {
      src: landingAssetPath('/landing_2025/src/img/Staff/gorki/joshua.webp'),
      alt: 'Мр Джошуа',
      name: 'Мр Джошуа',
      position: 'Учитель класса, Международная программа'
    },
    {
      src: landingAssetPath('/landing_2025/src/img/Staff/gorki/dani.webp'),
      alt: 'Мс Даниэлла',
      name: 'Мс Даниэлла',
      position: 'Учитель класса, Международная программа'
    },
    {
      src: landingAssetPath('/landing_2025/src/img/Staff/gorki/clara.webp'),
      alt: 'Мс Клара',
      name: 'Мс Клара',
      position: 'Учитель класса, Международная программа'
    },
    {
      src: landingAssetPath('/landing_2025/src/img/Staff/gorki/saliha.webp'),
      alt: 'Мс Салиха',
      name: 'Мс Салиха',
      position: 'Учитель начальных классов, Международная программа'
    },
    {
      src: landingAssetPath('/landing_2025/src/img/Staff/gorki/marius.webp'),
      alt: 'Мр Мариус',
      name: 'Мр Мариус',
      position: 'Учитель гуманитарных наук, Международная программа'
    },
    {
      src: landingAssetPath('/landing_2025/src/img/Staff/gorki/amanda.webp'),
      alt: 'Мс Аманда',
      name: 'Мс Аманда',
      position: 'Учитель актерского мастерства и математики, Международная программа'
    },
    {
      src: landingAssetPath('/landing_2025/src/img/Staff/gorki/charlz.webp'),
      alt: 'Мр Чарльз',
      name: 'Мр Чарльз',
      position: 'Учитель естественных наук, Международная программа'
    },
    {
      src: landingAssetPath('/landing_2025/src/img/Staff/gorki/ekat.webp'),
      alt: 'Мс Екатерина',
      name: 'Мс Екатерина',
      position: 'Координатор российской программы, учитель начальных классов'
    },
    {
      src: landingAssetPath('/landing_2025/src/img/Staff/gorki/anna.webp'),
      alt: 'Мс Анна',
      name: 'Мс Анна',
      position: 'Учитель класса, Международная программа'
    }
  ];

  // Данные преподавателей для Ташкента (10 преподавателей)
  const tashkentTeachers = [
    {
      src: landingAssetPath('/landing_2025/src/img/Staff/tashkent/runar.webp'),
      alt: 'Рунар Салимуллин',
      name: 'Рунар Салимуллин',
      position: 'Директор кампуса Ташкент'
    },
    {
      src: landingAssetPath('/landing_2025/src/img/Staff/tashkent/kim.webp'),
      alt: 'Кимберли Барбер',
      name: 'Кимберли Барбер',
      position: 'Заместитель директора по средней школе'
    },
    {
      src: landingAssetPath('/landing_2025/src/img/Staff/tashkent/kobus.webp'),
      alt: 'Кобус Стэндер',
      name: 'Кобус Стэндер',
      position: 'Заместитель директора по начальной школе'
    },
    {
      src: landingAssetPath('/landing_2025/src/img/Staff/tashkent/elena.webp'),
      alt: 'Елена Каневец',
      name: 'Елена Каневец',
      position: 'Учитель изобразительного искусства'
    },
    {
      src: landingAssetPath('/landing_2025/src/img/Staff/tashkent/lin.webp'),
      alt: 'Мс Дженнилин',
      name: 'Мс Дженнилин',
      position: 'Заместитель директора по детскому саду и начальной школе'
    },
    {
      src: landingAssetPath('/landing_2025/src/img/Staff/tashkent/jer.webp'),
      alt: 'Мр Жереми',
      name: 'Мр Жереми',
      position: 'Учитель класса, Международная программа'
    },
    {
      src: landingAssetPath('/landing_2025/src/img/Staff/tashkent/mart 4.webp'),
      alt: 'Мартина Каспарова',
      name: 'Мартина Каспарова',
      position: 'Учитель класса, Международная программа'
    },
    {
      src: landingAssetPath('/landing_2025/src/img/Staff/tashkent/scott.webp'),
      alt: 'Скотт Маклауд',
      name: 'Скотт Маклауд',
      position: 'Учитель класса, Международная программа'
    },
    {
      src: landingAssetPath('/landing_2025/src/img/Staff/tashkent/kris.webp'),
      alt: 'Кристофер Левер',
      name: 'Кристофер Левер',
      position: 'Учитель класса, Международная программа'
    },
    {
      src: landingAssetPath('/landing_2025/src/img/Staff/tashkent/jen.webp'),
      alt: 'Дженнифер Саммерхайес',
      name: 'Дженнифер Саммерхайес',
      position: 'Учитель класса, Международная программа'
    }
  ];

  const teachersByCampus = {
    skolkovo: baseTeachers,
    moscow: rotateTeachers(1),
    gorki: gorkiTeachers,
    spb: rotateTeachers(3),
    tashkent: tashkentTeachers
  };

  const block14CampusNames = {
    skolkovo: "Сколково",
    moscow: "Москва",
    gorki: "Горки",
    spb: "Санкт-Петербург",
    tashkent: "Ташкент"
  };
  
  // Функция для получения переведенного названия кампуса
  function getTranslatedCampusName(campusId) {
    const cms = window.block14CampusLabelsFromCms;
    if (cms && typeof cms === 'object' && campusId && cms[campusId]) {
      return cms[campusId];
    }
    const lang = localStorage.getItem('siteLanguage') || 'ru';
    if (typeof translations !== 'undefined' && translations[lang]) {
      const t = translations[lang];
      const campusNameMap = {
        'skolkovo': t.campus_name_skolkovo,
        'moscow': t.campus_name_moscow,
        'gorki': t.campus_name_gorki,
        'spb': t.campus_name_spb,
        'tashkent': t.campus_name_tashkent
      };
      if (campusNameMap[campusId]) {
        return campusNameMap[campusId];
      }
    }
    return block14CampusNames[campusId] || campusId;
  }
  
  // Данные отзывов для разных кампусов
  const reviewsDataByCampus = {
    tashkent: [
      {
        name: 'Кимберли Барбер',
        position: 'Заместитель директора по средней школе',
        text: 'Чтобы вдохновить студентов на учебу, мы смотрим на то, как темы, которые мы изучаем, влияют на их повседневную жизнь, и подчеркиваем сходство между ними и реальной жизнью. Актуальность изучаемых тем является ключевым аспектом.',
        avatar: landingAssetPath('/landing_2025/src/img/Staff/teacher_avatar_6-4fe702.webp'),
        alt: 'Кимберли Барбер'
      },
      {
        name: 'Мр Том Б.',
        position: 'Учитель английского языка, Кембриджская программа',
        text: 'Я считаю, что школьный кабинет — это площадка для творчества. Поэтому я провожу насыщенные уроки, включающие в себя прозу, поэзию и музыку. Я хочу, чтобы мои студенты развивали эмпатию, занимались самовыражением и воспринимали английский язык как мост, ведущий к пониманию мировых культур.',
        avatar: landingAssetPath('/landing_2025/src/img/Staff/teacher_avatar_2-6e93bc.webp'),
        alt: 'Мр Том Б.'
      },
      {
        name: 'Мс Даниэлла',
        position: 'Учитель класса, Кембриджская программа',
        text: 'У каждого ребенка есть врожденное стремление к знаниям, и моя обязанность как педагога - использовать различные стратегии, обеспечивающие успех каждого ученика. Я выступаю за практический подход, понимая, что ученики часто более вовлечены в процесс, когда они активно участвуют в нем - через движение, прикосновение или голосовое взаимодействие, - а не сидят пассивно с ручкой и бумагой.',
        avatar: landingAssetPath('/landing_2025/src/img/Staff/teacher_avatar_3-49d9b8.webp'),
        alt: 'Мс Даниэлла'
      },
      {
        name: 'Мр Пол',
        position: 'Учитель начальных классов, Международная программа',
        text: 'Я стараюсь сделать все уроки интересными, заставляющими задуматься и в меру сложными. Я постоянно спрашиваю себя, понравился ли бы мне урок, будь я студентом. Я прилагаю много усилий для планирования качественного обучения и стараюсь обеспечить эффективную обратную связь своим ученикам. Я возлагаю большие надежды на своих учеников, а вместе с тем и ответственность за качественную работу.',
        avatar: landingAssetPath('/landing_2025/src/img/Staff/teacher_avatar_7-Pol.png'),
        alt: 'Мр Пол'
      },
      {
        name: 'Мр Тим',
        position: 'Учитель актерского мастерства и английского языка, Международная программа',
        text: 'Я глубоко убежден в том, что образование должно основываться на ценностях, и считаю, что мой предмет — драма — играет важнейшую роль во всестороннем развитии ребенка. Я стремлюсь сделать обучение театральному искусству не только увлекательным и интересным, но и наполненным вызовами. Драма развивает навыки, которые мои ученики будут применять на протяжении всей своей жизни. Я уверен, что благодаря моим занятиям ребята становятся толерантнее, уважают различия и не боятся выражать себя.',
        avatar: landingAssetPath('/landing_2025/src/img/Staff/teacher_avatar_7-Tim.png'),
        alt: 'Мр Тим'
      },
      {
        name: 'Мр Алексей',
        position: 'Учитель математики, Международная программа',
        text: 'Я был очарован математикой еще в самом детстве. Моя бабушка преподавала ее в школе и заражала меня любовью к своему предмету. Ее педагогическое мастерство вызывало во мне огромное восхищение. Сегодня я стараюсь следовать ее примеру и так же пламенно вдохновлять своих учеников.',
        avatar: landingAssetPath('/landing_2025/src/img/Staff/teacher_avatar_7-Aleksey.png'),
        alt: 'Мр Алексей'
      }
    ],
    default: [
      {
        name: 'Кристофер Кингшотт',
        position: 'Директор кампуса Горки',
        text: 'Чтобы по-настоящему вдохновить студентов, важно самому быть увлеченным предметом, поскольку этот энтузиазм может быть невероятно заразительным. Понимая интересы и антипатии учащихся и соответствующим образом адаптируя свои методы обучения, вы сможете найти с ними общий язык и дать им наилучшие шансы на успех.',
        avatar: landingAssetPath('/landing_2025/src/img/Staff/teacher_avatar_1-62b7e4.webp'),
        alt: 'Кристофер Кингшотт'
      },
      {
        name: 'Мр Том Б.',
        position: 'Учитель английского языка, Кембриджская программа',
        text: 'Я считаю, что школьный кабинет — это площадка для творчества. Поэтому я провожу насыщенные уроки, включающие в себя прозу, поэзию и музыку. Я хочу, чтобы мои студенты развивали эмпатию, занимались самовыражением и воспринимали английский язык как мост, ведущий к пониманию мировых культур.',
        avatar: landingAssetPath('/landing_2025/src/img/Staff/teacher_avatar_2-6e93bc.webp'),
        alt: 'Мр Том Б.'
      },
      {
        name: 'Мс Даниэлла',
        position: 'Учитель класса, Кембриджская программа',
        text: 'У каждого ребенка есть врожденное стремление к знаниям, и моя обязанность как педагога - использовать различные стратегии, обеспечивающие успех каждого ученика. Я выступаю за практический подход, понимая, что ученики часто более вовлечены в процесс, когда они активно участвуют в нем - через движение, прикосновение или голосовое взаимодействие, - а не сидят пассивно с ручкой и бумагой.',
        avatar: landingAssetPath('/landing_2025/src/img/Staff/teacher_avatar_3-49d9b8.webp'),
        alt: 'Мс Даниэлла'
      },
      {
        name: 'Мр Пол',
        position: 'Учитель начальных классов, Международная программа',
        text: 'Я стараюсь сделать все уроки интересными, заставляющими задуматься и в меру сложными. Я постоянно спрашиваю себя, понравился ли бы мне урок, будь я студентом. Я прилагаю много усилий для планирования качественного обучения и стараюсь обеспечить эффективную обратную связь своим ученикам. Я возлагаю большие надежды на своих учеников, а вместе с тем и ответственность за качественную работу.',
        avatar: landingAssetPath('/landing_2025/src/img/Staff/teacher_avatar_7-Pol.png'),
        alt: 'Мр Пол'
      },
      {
        name: 'Мр Тим',
        position: 'Учитель актерского мастерства и английского языка, Международная программа',
        text: 'Я глубоко убежден в том, что образование должно основываться на ценностях, и считаю, что мой предмет — драма — играет важнейшую роль во всестороннем развитии ребенка. Я стремлюсь сделать обучение театральному искусству не только увлекательным и интересным, но и наполненным вызовами. Драма развивает навыки, которые мои ученики будут применять на протяжении всей своей жизни. Я уверен, что благодаря моим занятиям ребята становятся толерантнее, уважают различия и не боятся выражать себя.',
        avatar: landingAssetPath('/landing_2025/src/img/Staff/teacher_avatar_7-Tim.png'),
        alt: 'Мр Тим'
      },
      {
        name: 'Мр Алексей',
        position: 'Учитель математики, Международная программа',
        text: 'Я был очарован математикой еще в самом детстве. Моя бабушка преподавала ее в школе и заражала меня любовью к своему предмету. Ее педагогическое мастерство вызывало во мне огромное восхищение. Сегодня я стараюсь следовать ее примеру и так же пламенно вдохновлять своих учеников.',
        avatar: landingAssetPath('/landing_2025/src/img/Staff/teacher_avatar_7-Aleksey.png'),
        alt: 'Мр Алексей'
      }
    ]
  };
  
  // Функция для обновления отзывов в зависимости от кампуса
  function updateReviewsForCampus(campusId) {
    const reviewsSlides = document.getElementById('reviewsSlides');
    const reviewsSection = document.getElementById('block14ReviewsSection');
    if (!reviewsSlides) {
      return;
    }
    
    // Используем ТОЛЬКО данные из CMS
    const reviewsData = (window.cmsTeachersReviewsByCampus && window.cmsTeachersReviewsByCampus[campusId]) || [];
    
    // Если нет данных, скрываем блок
    if (reviewsData.length === 0) {
      if (reviewsSection) reviewsSection.style.display = 'none';
      return;
    }
    
    // Показываем блок, если есть данные
    if (reviewsSection) reviewsSection.style.display = '';
    
    const locale = window.cmsLocale || '';
    const lang = localStorage.getItem('siteLanguage') || 'ru';
    const t = typeof translations !== 'undefined' && translations[lang] ? translations[lang] : null;
    const expandText = (t && t.review_expand) ? t.review_expand : 'Развернуть';
    
    reviewsSlides.innerHTML = '';
    
    reviewsData.forEach((item) => {
      const card = document.createElement('a');
      card.className = 'review_card';
      card.href = item.slug ? `${locale}teachers/${item.slug}/` : 'javascript:void(0)';
      card.setAttribute('itemscope', '');
      card.setAttribute('itemtype', 'https://schema.org/Review');
      
      card.innerHTML = `
        <div class="review_top">
          <img src="${item.image}" alt="${item.name}" class="review_avatar" itemscope itemtype="https://schema.org/ImageObject"/>
          <div class="review_header">
            <div itemprop="author" itemscope itemtype="https://schema.org/Person">
              <h3 class="review_name"><span itemprop="name">${item.name}</span></h3>
              <p class="review_position"><span itemprop="jobTitle">${item.position}</span></p>
            </div>
          </div>
        </div>
        <p class="review_text" itemprop="reviewBody">${item.text || ''}</p>
        <button class="review_expand" type="button">${expandText}</button>
      `;
      
      const expandBtn = card.querySelector('.review_expand');
      if (expandBtn) {
        expandBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          // Переключаем класс expanded на карточке
          card.classList.toggle('expanded');
          
          // Меняем текст кнопки
          const isExpanded = card.classList.contains('expanded');
          if (t && t.review_collapse && isExpanded) {
            expandBtn.textContent = t.review_collapse;
          } else {
            expandBtn.textContent = expandText;
          }
        });
      }
      
      reviewsSlides.appendChild(card);
    });
    
    if (typeof window.updateReviewsCarousel === 'function') {
      setTimeout(() => window.updateReviewsCarousel(), 50);
    }
  }
  
  // Делаем функцию глобальной для доступа из других мест
  window.updateReviewsForCampus = updateReviewsForCampus;

  function applyTeachers(campusKey) {
    // Используем ТОЛЬКО данные из CMS
    const data = (window.cmsTeachersByCampus && window.cmsTeachersByCampus[campusKey]) || [];
    
    if (data.length === 0) {
      return;
    }

    // Удаляем все существующие карточки (включая клоны)
    const allCards = teachersSlides.querySelectorAll('.teacher_card, .teacher-card-clone');
    allCards.forEach(card => card.remove());
    
    // Создаем новые карточки на основе данных из CMS
    const locale = window.cmsLocale || '';
    
    data.forEach((item) => {
      const card = document.createElement('a');
      card.className = 'teacher_card';
      card.href = item.slug ? `${locale}teachers/${item.slug}/` : 'javascript:void(0)';
      
      const img = document.createElement('img');
      img.src = item.image;
      img.alt = item.name;
      img.className = 'teacher_photo';
      img.setAttribute('itemscope', '');
      img.setAttribute('itemtype', 'https://schema.org/ImageObject');
      
      const info = document.createElement('div');
      info.className = 'teacher_info';
      
      const nameEl = document.createElement('div');
      nameEl.className = 'teacher_name';
      nameEl.textContent = item.name;
      
      const positionEl = document.createElement('div');
      positionEl.className = 'teacher_position';
      positionEl.textContent = item.position;
      
      info.appendChild(nameEl);
      info.appendChild(positionEl);
      card.appendChild(img);
      card.appendChild(info);
      teachersSlides.appendChild(card);
    });
    
    // Обновляем список карточек
    teacherCards = Array.from(teachersSlides.querySelectorAll('.teacher_card'));
    
    // Обновляем карусель после изменения количества карточек
    if (typeof window.updateTeachersCarousel === 'function') {
      setTimeout(() => window.updateTeachersCarousel(), 50);
    }
    
    // Обновляем навигацию на десктопе после изменения количества карточек
    if (typeof window.updateTeachersNavigation === 'function') {
      setTimeout(() => window.updateTeachersNavigation(), 50);
    }
  }
  
  // Делаем функцию глобальной для доступа из applyRegion
  window.applyTeachers = applyTeachers;

  // Обработчики для кнопок (если они есть на мобильной версии)
  campusButtons.forEach(button => {
    button.addEventListener('click', () => {
      const campusKey = button.getAttribute('data-campus');
      if (!campusKey) return;

      // Синхронизируем выбор города во всех блоках (включая контент)
      syncCampusSelection(campusKey);

      campusButtons.forEach(btn => btn.classList.remove('active'));
      button.classList.add('active');

      // Применяем переводы после смены кампуса
      const lang = localStorage.getItem('siteLanguage') || 'ru';
      if (typeof window.translatePage === 'function') {
        window.translatePage(lang);
      }

      if (block14SelectedCampus) {
        block14SelectedCampus.textContent = getTranslatedCampusName(campusKey);
      }
      if (block14SelectedCampusMobile) {
        block14SelectedCampusMobile.textContent = getTranslatedCampusName(campusKey);
      }
    });
  });

  // Обновляет текст селектора кампуса во всех видимых элементах (в т.ч. при дубликатах в DOM)
  function updateBlock14SelectorDisplay(campusId) {
    const campusName = getTranslatedCampusName(campusId);
    document.querySelectorAll('[id="block14SelectedCampus"], [id="block14SelectedCampusMobile"]').forEach(el => {
      el.textContent = campusName;
    });
    document.querySelectorAll('.block14_campus_option').forEach((opt) => {
      const active = opt.getAttribute('data-campus') === campusId;
      opt.classList.toggle('active', active);
      opt.classList.toggle('selected', active);
    });
  }
  window.updateBlock14SelectorDisplay = updateBlock14SelectorDisplay;

  function selectBlock14Campus(campusId, fromUserClick) {
    var isInternalStaffPage =
      !!document.querySelector('[data-landing-staff-js]') ||
      document.body.classList.contains('kindergarten-page');

    if (fromUserClick || isInternalStaffPage) {
      window.block14UserSelectedCampus = campusId;
    }
    // Синхронизируем выбор города во всех блоках
    syncCampusSelection(campusId);
    
    updateBlock14SelectorDisplay(campusId);

    // закрываем модалку
    if (block14CampusModal) {
      block14CampusModal.classList.remove('open');
    }
    
    // закрываем мобильную модалку
    if (block14CampusModalMobile) {
      block14CampusModalMobile.classList.remove('open');
    }

    if (block14CampusSelectorBtn) {
      block14CampusSelectorBtn.classList.remove('menu-open');
    }
    
    if (block14CampusSelectorBtnMobile) {
      block14CampusSelectorBtnMobile.classList.remove('menu-open');
    }

    // активируем кнопку (если они есть) и применяем преподавателей
    if (campusButtons.length > 0) {
    campusButtons.forEach(btn => {
      btn.classList.remove('active');
      if (btn.getAttribute('data-campus') === campusId) {
        btn.classList.add('active');
      }
    });
    }

    document.querySelectorAll('.block14_campus_option').forEach((opt) => {
      const active = opt.getAttribute('data-campus') === campusId;
      opt.classList.toggle('active', active);
      opt.classList.toggle('selected', active);
    });
  }

  // Инициализация селектора кампусов
  let initAttempts = 0;
  const maxInitAttempts = 10;
  
  function initBlock14CampusSelector() {
    // Начальная школа: селектор block14 вешает public/primary/js/script.js (initSecondaryStaff) — иначе дубль кликов.
    // Детсад: этот блок живёт в internal_2025 и должен инициализироваться отсюда.
    // Средняя/старшая (middle-high-page): тот же data-secondary-staff, но secondary/script.js при наличии applyTeachers из бандла выходит раньше — селектор обязан вешать teachersSlider.
    if (document.body.classList.contains('primary-school-page')) {
      return;
    }
    if (document.querySelector('[data-secondary-staff]') &&
        !document.body.classList.contains('middle-high-page') &&
        !document.body.classList.contains('kindergarten-page')) {
      return;
    }

    const btn = document.getElementById('block14CampusSelectorBtn');
    const modal = document.getElementById('block14CampusModal');
    const btnMobile = document.getElementById('block14CampusSelectorBtnMobile');
    const modalMobile = document.getElementById('block14CampusModalMobile');
    const options = document.querySelectorAll('.block14_campus_option');

    if (window.__block14CampusSelectorBound) {
      return;
    }
    
    // Инициализируем десктопный селектор
    if (btn && modal) {
      // Проверяем, не привязаны ли уже обработчики
      if (!btn.hasAttribute('data-selector-initialized')) {
        btn.setAttribute('data-selector-initialized', 'true');

        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          modal.classList.toggle('open');
          btn.classList.toggle('menu-open');
        });
      }
    }
    
    // Инициализируем мобильный селектор
    if (btnMobile && modalMobile) {
      // Проверяем, не привязаны ли уже обработчики
      if (!btnMobile.hasAttribute('data-selector-initialized')) {
        btnMobile.setAttribute('data-selector-initialized', 'true');

        btnMobile.addEventListener('click', (e) => {
          e.stopPropagation();
          modalMobile.classList.toggle('open');
          btnMobile.classList.toggle('menu-open');
        });
      }
    }
    
    // Обработчики для опций (работают для обоих селекторов)
    options.forEach(option => {
      if (!option.hasAttribute('data-option-initialized')) {
        option.setAttribute('data-option-initialized', 'true');
        option.addEventListener('click', (e) => {
          e.stopPropagation();
          const campusId = option.getAttribute('data-campus');
          if (campusId) {
            selectBlock14Campus(campusId, true);
          }
        });
      }
    });

    if (!window.__block14CampusSelectorOutsideHandlerBound) {
      window.__block14CampusSelectorOutsideHandlerBound = true;
      document.addEventListener('click', (e) => {
        const clickedDesktop = (btn && btn.contains(e.target)) || (modal && modal.contains(e.target));
        const clickedMobile = (btnMobile && btnMobile.contains(e.target)) || (modalMobile && modalMobile.contains(e.target));
        if (clickedDesktop || clickedMobile) return;

        if (modal) {
          modal.classList.remove('open');
        }
        if (btn) {
          btn.classList.remove('menu-open');
        }
        if (modalMobile) {
          modalMobile.classList.remove('open');
        }
        if (btnMobile) {
          btnMobile.classList.remove('menu-open');
        }
      });
    }
    
    if ((!btn || !modal) && (!btnMobile || !modalMobile)) {
      initAttempts++;
      // Если элементы не найдены, пробуем еще раз через небольшую задержку (но не более maxInitAttempts раз)
      if (initAttempts < maxInitAttempts) {
        setTimeout(initBlock14CampusSelector, 100);
      }
      return;
    }

    window.__block14CampusSelectorBound = true;
  }

  // Инициализируем селектор
  initBlock14CampusSelector();

  // Определяем кампус по умолчанию в зависимости от региона
  // Для en-uz и ru-uz: регион из URL (cookie может быть от предыдущего визита)
  function getDefaultCampusForTeachers() {
    const pathMatch = window.location.pathname.match(/^\/([a-z]{2})-([a-z]{2})(\/.*)?$/);
    if (pathMatch && pathMatch[2] === 'uz') {
      return 'tashkent';
    }
    const curCountryEl = document.getElementById('curCountry');
    if (curCountryEl) {
      const isUzbekistanRegion = curCountryEl.textContent.trim() === 'Узбекистан' || curCountryEl.textContent.trim() === 'Uzbekistan';
      // Для Узбекистана - Ташкент, для России - Горки
      return isUzbekistanRegion ? 'tashkent' : 'gorki';
    }
    // По умолчанию Горки (для России)
    return 'gorki';
  }
  
  // internal_2025: кампус с сервера (чекбоксы CMS привязаны к кампусу); иначе — как на главной (регион)
  const internalStaffEl = document.querySelector('[data-landing-staff-js]');
  const defaultCampus = (internalStaffEl && internalStaffEl.getAttribute('data-default-campus'))
    ? internalStaffEl.getAttribute('data-default-campus')
    : getDefaultCampusForTeachers();
  
  // Устанавливаем кампус по умолчанию в селекторе
  if (block14SelectedCampus) {
    const defaultCampusName = getTranslatedCampusName(defaultCampus);
    block14SelectedCampus.textContent = defaultCampusName;
  }
  // Устанавливаем кампус по умолчанию в мобильном селекторе
  if (block14SelectedCampusMobile) {
    const defaultCampusName = getTranslatedCampusName(defaultCampus);
    block14SelectedCampusMobile.textContent = defaultCampusName;
  }
  
  // Вызываем сразу, но с небольшой задержкой для гарантии, что DOM готов
  setTimeout(() => {
    selectBlock14Campus(defaultCampus);
    // Обновляем отзывы для дефолтного кампуса
    if (typeof window.updateReviewsForCampus === 'function') {
      window.updateReviewsForCampus(defaultCampus);
    }
  }, 100);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBlock14CampusSwitching);
  } else {
    initBlock14CampusSwitching();
  }
})();


// Бесконечная карусель для teachers_slider_wrapper при 768px (как slider_container)
// ============================================
(function() {
  if (document.body.classList.contains('middle-high-page') && !document.querySelector('[data-landing-staff-js]')) return;
  let teachersSlides = null;
  let teachersSliderWrapper = null;
  let currentTeacherIndex = 0;
  let isTransitioning = false;
  let isAnimating = false;
  const teacherGap = 30;
  const teacherWidth = 200;

  function getTeacherWidth() {
    return teacherWidth;
  }

  function getTeacherStep() {
    return getTeacherWidth() + teacherGap;
  }

  function getTransitionDuration() {
    return '0.4s';
  }

  function getTransitionDurationMs() {
    return 400;
  }

  function getRealTeachers() {
    if (!teachersSlides) return [];
    return Array.from(teachersSlides.querySelectorAll('.teacher_card:not(.teacher-card-clone)'));
  }

  function cloneTeachers() {
    if (!teachersSlides || window.innerWidth > 768) {
      if (teachersSlides) {
        const oldClones = teachersSlides.querySelectorAll('.teacher-card-clone');
        oldClones.forEach(clone => clone.remove());
      }
      return;
    }

    const realTeachers = getRealTeachers();
    if (realTeachers.length === 0) return;

    const oldClones = teachersSlides.querySelectorAll('.teacher-card-clone');
    oldClones.forEach(clone => clone.remove());

    const fragmentBefore = document.createDocumentFragment();
    realTeachers.forEach(card => {
      const clone = card.cloneNode(true);
      clone.classList.add('teacher-card-clone');
      fragmentBefore.appendChild(clone);
    });
    teachersSlides.insertBefore(fragmentBefore, realTeachers[0]);

    realTeachers.forEach(card => {
      const clone = card.cloneNode(true);
      clone.classList.add('teacher-card-clone');
      teachersSlides.appendChild(clone);
    });
  }

  function updateTeachersSlider() {
    if (!teachersSlides || window.innerWidth > 768) return;

    const realTeachers = getRealTeachers();
    if (realTeachers.length === 0) return;

    // Ограничиваем индекс реальными элементами
    if (currentTeacherIndex < 0) {
      currentTeacherIndex = 0;
    }
    if (currentTeacherIndex >= realTeachers.length) {
      currentTeacherIndex = realTeachers.length - 1;
    }

    const centerX = window.innerWidth / 2;
    const containerRect = teachersSliderWrapper ? teachersSliderWrapper.getBoundingClientRect() : teachersSlides.getBoundingClientRect();
    const containerLeft = containerRect.left;

    const currentTeacherWidth = getTeacherWidth();
    const currentTeacherStep = getTeacherStep();
    const teacherCenterX = currentTeacherWidth / 2;
    const realTeacherIndexInDOM = realTeachers.length + currentTeacherIndex;
    const activeTeacherLeftPosition = realTeacherIndexInDOM * currentTeacherStep;
    const activeTeacherCenterPosition = activeTeacherLeftPosition + teacherCenterX;

    const translateX = centerX - containerLeft - activeTeacherCenterPosition;

    // Всегда устанавливаем transition для обычных переходов
    if (!isTransitioning) {
      teachersSlides.style.transition = `transform ${getTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
    }
    teachersSlides.style.transform = `translateX(${translateX}px)`;
  }

  function goToNextTeacher() {
    if (isAnimating || window.innerWidth > 768) return;

    const realTeachers = getRealTeachers();
    const realTeachersCount = realTeachers.length;

    if (currentTeacherIndex < realTeachersCount - 1) {
      isAnimating = true;
      currentTeacherIndex++;
      updateTeachersSlider();
      setTimeout(() => {
        isAnimating = false;
      }, getTransitionDurationMs());
    } else {
      if (isTransitioning || isAnimating) return;
      isTransitioning = true;
      isAnimating = true;

      const firstCloneIndex = realTeachersCount * 2;
      const currentTeacherStep = getTeacherStep();
      const containerRect = teachersSliderWrapper ? teachersSliderWrapper.getBoundingClientRect() : teachersSlides.getBoundingClientRect();
      const containerLeft = containerRect.left;
      const currentTeacherWidth = getTeacherWidth();
      const teacherCenterX = currentTeacherWidth / 2;
      const activeTeacherLeftPosition = firstCloneIndex * currentTeacherStep;
      const activeTeacherCenterPosition = activeTeacherLeftPosition + teacherCenterX;
      const viewportCenter = window.innerWidth / 2;
      const translateX = viewportCenter - containerLeft - activeTeacherCenterPosition;

      teachersSlides.style.transition = `transform ${getTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
      teachersSlides.style.transform = `translateX(${translateX}px)`;

      setTimeout(() => {
        teachersSlides.style.transition = 'none';
        currentTeacherIndex = 0;
        const realTeachersCount = realTeachers.length;
        const currentTeacherStep = getTeacherStep();
        const containerRect = teachersSliderWrapper ? teachersSliderWrapper.getBoundingClientRect() : teachersSlides.getBoundingClientRect();
        const containerLeft = containerRect.left;
        const currentTeacherWidth = getTeacherWidth();
        const teacherCenterX = currentTeacherWidth / 2;
        const realTeacherIndexInDOM = realTeachersCount + currentTeacherIndex;
        const activeTeacherLeftPosition = realTeacherIndexInDOM * currentTeacherStep;
        const activeTeacherCenterPosition = activeTeacherLeftPosition + teacherCenterX;
        const viewportCenter = window.innerWidth / 2;
        const translateX = viewportCenter - containerLeft - activeTeacherCenterPosition;
        teachersSlides.style.transform = `translateX(${translateX}px)`;
        
        requestAnimationFrame(() => {
          setTimeout(() => {
            isTransitioning = false;
            isAnimating = false;
            teachersSlides.style.transition = `transform ${getTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
          }, 0.0001);
        });
      }, getTransitionDurationMs());
    }
  }

  function goToPrevTeacher() {
    if (isAnimating || window.innerWidth > 768) return;

    const realTeachers = getRealTeachers();
    const realTeachersCount = realTeachers.length;

    if (currentTeacherIndex > 0) {
      isAnimating = true;
      currentTeacherIndex--;
      updateTeachersSlider();
      setTimeout(() => {
        isAnimating = false;
      }, getTransitionDurationMs());
    } else {
      if (isTransitioning || isAnimating) return;
      isTransitioning = true;
      isAnimating = true;

      const lastCloneIndex = realTeachersCount - 1;
      const currentTeacherStep = getTeacherStep();
      const containerRect = teachersSliderWrapper ? teachersSliderWrapper.getBoundingClientRect() : teachersSlides.getBoundingClientRect();
      const containerLeft = containerRect.left;
      const currentTeacherWidth = getTeacherWidth();
      const teacherCenterX = currentTeacherWidth / 2;
      const activeTeacherLeftPosition = lastCloneIndex * currentTeacherStep;
      const activeTeacherCenterPosition = activeTeacherLeftPosition + teacherCenterX;
      const viewportCenter = window.innerWidth / 2;
      const translateX = viewportCenter - containerLeft - activeTeacherCenterPosition;

      teachersSlides.style.transition = `transform ${getTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
      teachersSlides.style.transform = `translateX(${translateX}px)`;

      setTimeout(() => {
        teachersSlides.style.transition = 'none';
        currentTeacherIndex = realTeachersCount - 1;
        const currentTeacherStep = getTeacherStep();
        const containerRect = teachersSliderWrapper ? teachersSliderWrapper.getBoundingClientRect() : teachersSlides.getBoundingClientRect();
        const containerLeft = containerRect.left;
        const currentTeacherWidth = getTeacherWidth();
        const teacherCenterX = currentTeacherWidth / 2;
        const realTeacherIndexInDOM = realTeachersCount + currentTeacherIndex;
        const activeTeacherLeftPosition = realTeacherIndexInDOM * currentTeacherStep;
        const activeTeacherCenterPosition = activeTeacherLeftPosition + teacherCenterX;
        const viewportCenter = window.innerWidth / 2;
        const translateX = viewportCenter - containerLeft - activeTeacherCenterPosition;
        teachersSlides.style.transform = `translateX(${translateX}px)`;
        
        requestAnimationFrame(() => {
          setTimeout(() => {
            isTransitioning = false;
            isAnimating = false;
            teachersSlides.style.transition = `transform ${getTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
          }, 0.0001);
        });
      }, getTransitionDurationMs());
    }
  }

  function getInitialTranslate() {
    const realTeachers = getRealTeachers();
    const containerRect = teachersSliderWrapper ? teachersSliderWrapper.getBoundingClientRect() : teachersSlides.getBoundingClientRect();
    const containerLeft = containerRect.left;
    const centerX = window.innerWidth / 2;
    const currentTeacherWidth = getTeacherWidth();
    const currentTeacherStep = getTeacherStep();
    const teacherCenterX = currentTeacherWidth / 2;
    const realTeacherIndexInDOM = realTeachers.length + currentTeacherIndex;
    const activeTeacherLeftPosition = realTeacherIndexInDOM * currentTeacherStep;
    const activeTeacherCenterPosition = activeTeacherLeftPosition + teacherCenterX;

    if (window.innerWidth <= 768 && currentTeacherIndex === 0) {
      const viewportCenter = window.innerWidth / 2;
      return viewportCenter - containerLeft - activeTeacherCenterPosition;
    } else {
      return centerX - containerLeft - activeTeacherCenterPosition;
    }
  }

  function cleanup() {
    if (!teachersSlides) return;
    
    // Удаляем все клоны
    const oldClones = teachersSlides.querySelectorAll('.teacher-card-clone');
    oldClones.forEach(clone => clone.remove());
    
    // Сбрасываем стили
    teachersSlides.style.transform = '';
    teachersSlides.style.transition = '';
    teachersSlides.classList.remove('dragging');
    
    // Сбрасываем флаги
    isTransitioning = false;
    isAnimating = false;
  }

  // Храним обработчики для возможности их удаления
  let mouseDownHandler = null;
  let mouseMoveHandler = null;
  let mouseUpHandler = null;
  let mouseLeaveHandler = null;
  let touchStartHandler = null;
  let touchMoveHandler = null;
  let touchEndHandler = null;

  function removeEventListeners() {
    if (!teachersSlides) return;
    
    if (mouseDownHandler) {
      teachersSlides.removeEventListener('mousedown', mouseDownHandler);
      mouseDownHandler = null;
    }
    if (mouseMoveHandler) {
      teachersSlides.removeEventListener('mousemove', mouseMoveHandler);
      mouseMoveHandler = null;
    }
    if (mouseUpHandler) {
      teachersSlides.removeEventListener('mouseup', mouseUpHandler);
      mouseUpHandler = null;
    }
    if (mouseLeaveHandler) {
      teachersSlides.removeEventListener('mouseleave', mouseLeaveHandler);
      mouseLeaveHandler = null;
    }
    if (touchStartHandler) {
      teachersSlides.removeEventListener('touchstart', touchStartHandler);
      touchStartHandler = null;
    }
    if (touchMoveHandler) {
      teachersSlides.removeEventListener('touchmove', touchMoveHandler);
      touchMoveHandler = null;
    }
    if (touchEndHandler) {
      teachersSlides.removeEventListener('touchend', touchEndHandler);
      touchEndHandler = null;
    }
  }

  function init() {
    // Если больше 768px, очищаем и выходим
    if (window.innerWidth > 768) {
      cleanup();
      removeEventListeners();
      return;
    }

    teachersSlides = document.getElementById('teachersSlides');
    if (!teachersSlides) return;

    // Удаляем старые обработчики перед добавлением новых
    removeEventListeners();

    teachersSliderWrapper = teachersSlides.closest('.teachers_slider_wrapper') || teachersSlides.parentElement;

    let isDragging = false;
    let startX = 0;
    let currentX = 0;
    let initialTranslate = 0;
    let touchStartX = 0;
    let touchStartY = 0;
    let touchCurrentX = 0;
    let touchInitialTranslate = 0;

    // Сначала клонируем, потом устанавливаем индекс и обновляем
    cloneTeachers();
    currentTeacherIndex = 0; // Герман Каррера - первый элемент (индекс 0)
    
    // Инициализация позиции
    const initialTeachers = teachersSlides.querySelectorAll('.teacher_card');
    if (initialTeachers.length > 0) {
      updateTeachersSlider();
    }

    mouseDownHandler = (e) => {
      if (isTransitioning || isAnimating || window.innerWidth > 768) return;
      isDragging = true;
      startX = e.clientX;
      initialTranslate = getInitialTranslate();
      teachersSlides.classList.add('dragging');
      e.preventDefault();
    };
    teachersSlides.addEventListener('mousedown', mouseDownHandler);

    mouseMoveHandler = (e) => {
      if (!isDragging) return;
      currentX = e.clientX - startX;
      teachersSlides.style.transform = `translateX(${initialTranslate + currentX}px)`;
    };
    teachersSlides.addEventListener('mousemove', mouseMoveHandler);

    mouseUpHandler = () => {
      if (!isDragging) return;
      isDragging = false;
      teachersSlides.classList.remove('dragging');

      const threshold = getTeacherStep() / 6;
      if (Math.abs(currentX) > threshold) {
        if (currentX > 0) {
          goToPrevTeacher();
        } else {
          goToNextTeacher();
        }
      } else {
        updateTeachersSlider();
      }
      currentX = 0;
    };
    teachersSlides.addEventListener('mouseup', mouseUpHandler);

    mouseLeaveHandler = () => {
      if (isDragging) {
        isDragging = false;
        teachersSlides.classList.remove('dragging');
        updateTeachersSlider();
        currentX = 0;
      }
    };
    teachersSlides.addEventListener('mouseleave', mouseLeaveHandler);

    touchStartHandler = (e) => {
      if (isTransitioning || isAnimating || window.innerWidth > 768) return;
      isDragging = true;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchInitialTranslate = getInitialTranslate();
      teachersSlides.classList.add('dragging');
    };
    teachersSlides.addEventListener('touchstart', touchStartHandler);

    touchMoveHandler = (e) => {
      if (!isDragging) return;
      touchCurrentX = e.touches[0].clientX - touchStartX;
      const touchCurrentY = e.touches[0].clientY - touchStartY;

      if (Math.abs(touchCurrentX) > Math.abs(touchCurrentY) && Math.abs(touchCurrentX) > 5) {
        e.preventDefault();
      }

      teachersSlides.style.transform = `translateX(${touchInitialTranslate + touchCurrentX}px)`;
    };
    teachersSlides.addEventListener('touchmove', touchMoveHandler);

    touchEndHandler = () => {
      if (!isDragging) return;
      isDragging = false;
      teachersSlides.classList.remove('dragging');

      const threshold = getTeacherStep() / 6;
      if (Math.abs(touchCurrentX) > threshold) {
        if (touchCurrentX > 0) {
          goToPrevTeacher();
        } else {
          goToNextTeacher();
        }
      } else {
        updateTeachersSlider();
      }
      touchCurrentX = 0;
    };
    teachersSlides.addEventListener('touchend', touchEndHandler);

  }

  // Глобальный обработчик resize
  let resizeTimeout;
  let isResizing = false;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (isResizing) return;
      isResizing = true;
      
      const wasMobile = window.innerWidth <= 768;
      const isMobile = window.innerWidth <= 768;
      
      if (wasMobile !== isMobile) {
        // Переход между режимами - полная переинициализация
        if (isMobile) {
          // Переход на мобильный режим
          init();
        } else {
          // Переход на десктопный режим
          cleanup();
        }
      } else if (isMobile) {
        // Остаемся в мобильном режиме - обновляем позицию
        if (teachersSlides) {
          cloneTeachers();
          updateTeachersSlider();
        }
      }
      
      isResizing = false;
    }, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(init, 300);
    });
  } else {
    setTimeout(init, 300);
  }

  window.addEventListener('load', () => {
    if (window.innerWidth <= 768) {
      currentTeacherIndex = 0;
      updateTeachersSlider();
    }
  });

  // Глобальная функция для обновления карусели после изменения количества карточек
  window.updateTeachersCarousel = function() {
    if (window.innerWidth <= 768) {
      currentTeacherIndex = 0;
      cloneTeachers();
      updateTeachersSlider();
    }
  };
})();
